/* eslint-disable @typescript-eslint/no-explicit-any */
// import { logEvent as firebaseLogEvent, getAnalytics } from "firebase/analytics";
// import { initializeApp } from "firebase/app";

// import { _env } from "@/config/environment";

// interface IFirebaseEnvProps {
//   apiKey: string;
//   authDomain: string;
//   projectId: string;
//   storageBucket: string;
//   messagingSenderId: string;
//   appId: string;
//   measurementId?: string;
// }

// const firebaseConfig: IFirebaseEnvProps = {
//   apiKey: _env.firebaseApiKey,
//   authDomain: _env.firebaseAuthDomain,
//   projectId: _env.firebaseProjectId,
//   storageBucket: _env.firebaseStorageBucket,
//   messagingSenderId: _env.firebaseMessagingSenderId,
//   appId: _env.firebaseAppId,
//   measurementId: _env.firebaseMeasurementId,
// };

// // const app = initializeApp(firebaseConfig);
// const analytics =
//   _env.isProduction && typeof window !== "undefined"
//     ? undefined //getAnalytics(app)
//     : undefined;

function logEvent(eventName: string, eventParams?: Record<string, any>) {
  console.log(eventName, eventParams)
  // if (analytics) firebaseLogEvent(analytics, eventName, eventParams);
}

export { logEvent };
